import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbAlertModule,
  NgbModalModule,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  CheckboxModule,
  NfFormsModule,
} from '@northfork/ng-basics'
import { CashBreakAdvancedSettingsModalComponent } from './components/cash-break-advanced-settings-modal/cash-break-advanced-settings-modal.component'
import { CashBreakSuggestionsModalComponent } from './components/cash-break-suggestions-modal/cash-break-suggestions-modal.component'
import { CashBreakService } from './services/cash-break/cash-break.service'
import { CopilotService } from './services/copilot/copilot.service'
import { AvailableActionService } from './services/available-action.service'
import { CashBreakSuggestionsService } from './services/cash-break/cash-break-suggestions.service'
import { HttpCopilotService } from './services/copilot/http-copilot.service'

@NgModule({
  imports: [
    // Angular Dependencies
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Northfork Dependencies
    NgbModalModule,
    NgbNavModule,
    TableLayoutModule,
    ButtonModule,
    NgbAlertModule,
    CheckboxModule,
    NfFormsModule,

    // Helios Dependencies
    GenericComponentsModule,
  ],
  declarations: [
    CashBreakSuggestionsModalComponent,
    CashBreakAdvancedSettingsModalComponent,
  ],
  providers: [CopilotService, CashBreakService],
})
export class CopilotModule {}
